function addUnitText (text, unit) {
    return [text, unit && `(${unit})`].filter(Boolean).join(' ').trim()
}

export {
    addUnitText,
}